import { render, staticRenderFns } from "./DomainTransferRequestView.vue?vue&type=template&id=1250a25b&scoped=true&"
import script from "./DomainTransferRequestView.vue?vue&type=script&lang=js&"
export * from "./DomainTransferRequestView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1250a25b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1250a25b')) {
      api.createRecord('1250a25b', component.options)
    } else {
      api.reload('1250a25b', component.options)
    }
    module.hot.accept("./DomainTransferRequestView.vue?vue&type=template&id=1250a25b&scoped=true&", function () {
      api.rerender('1250a25b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/domains/DomainTransferRequestView.vue"
export default component.exports